import React = require("react")

export default function getImage(props: any) {
    return <img src={props.src}/>
} 


// WEBPACK FOOTER //
// ./src/atomic/image.tsx